import * as React from "react";
const NavHeartIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={29}
    viewBox="0 0 32 29"
    fill="none"
    {...props}
  >
    <path
      d="M16 28.573c-.438 0-.864-.058-1.218-.19C9.371 26.473.772 19.692.772 9.673.771 4.569 4.78.427 9.71.427c2.394 0 4.632.962 6.29 2.683A8.68 8.68 0 0 1 22.29.427c4.93 0 8.939 4.156 8.939 9.246 0 10.033-8.6 16.8-14.011 18.71-.354.132-.78.19-1.218.19M9.71 2.615c-3.754 0-6.814 3.164-6.814 7.058 0 9.96 9.308 15.502 12.58 16.654.255.087.808.087 1.063 0 3.258-1.152 12.58-6.68 12.58-16.654 0-3.894-3.06-7.058-6.814-7.058-2.154 0-4.151 1.035-5.44 2.829-.397.554-1.303.554-1.7 0-1.318-1.809-3.301-2.83-5.454-2.83"
      fill={process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#4564A9"}
    />
  </svg>
);
export default NavHeartIcon;
